import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Decoline } from 'components';
import ReactMarkdown from 'react-markdown';
import { useLocation } from 'react-use';

const FaqAnswerCard = ({ question, answer, id, tags }) => {
    const { pathname, host } = useLocation();
    const idPreface = 'faqanswer';
    return (
        <div className="faqAnswerCard">
            <div>
                <h5 onClick={ () => {navigator.clipboard.writeText(`${host}${pathname}#${idPreface}${id}`);} } id={ `${idPreface}${id}` }>{ question }</h5>
            </div>
            <Decoline />
            { /* tags.length > 0 &&
            <div className="tags">
                { tags.map(tag => (
                    <Tag key={ tag.id }>{ tag.name }</Tag>
                )) }
            </div>
                */ }
            <ReactMarkdown source={ answer } />
        </div>
    );
};

FaqAnswerCard.defaultProps = {};

FaqAnswerCard.propTypes = {
    question: PropTypes.string,
    answer: PropTypes.string,
    id: PropTypes.string,
    tags: PropTypes.array,
};

export default FaqAnswerCard;
